import React from "react";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import AppInput from "components/ui/AppInput";
import AppSelect from "components/ui/AppSelect";
import AppButton from "components/ui/AppButton";
import AppOutlineButton from "components/ui/AppOutlineButton";

function ZoneForm({
  onClose,
  selectedAreaState,
  handleValues,
  handleInputValue,
  handleSubmit,
  heading,
  resetState,
}) {
  const { t } = useTranslation();
  const daysOptions = Array.from({ length: 8 }, (_, value) => ({
    label: `${value} ${t("Days")}`,
    value,
  }));
  const hourOptions = Array.from({ length: 24 }, (_, value) => ({
    label: `${value} ${t("Hours")}`,
    value,
  }));
  const minuteOptions = Array.from({ length: 12 }, (_, index) => ({
    label: `${index * 5} ${t("Minutes")}`,
    value: index * 5,
  }));

  return (
    <div className="w-full ">
      <div className="grid grid-cols-2 gap-4">
        <AppInput
          label={t("Zone Name")}
          mandatory={true}
          value={selectedAreaState?.name}
          onInput={(e) => handleValues("name", e.target.value)}
        />
        <AppInput
          label={t("Distance")}
          mandatory={true}
          type="number"
          value={selectedAreaState?.distance}
          onInput={(e) => handleInputValue("distance", e.target.value)}
        />
      </div>

      <div className="mt-4 grid grid-cols-2 gap-4">
        <AppInput
          label={t("Min. Basket Value")}
          mandatory={true}
          type="number"
          value={selectedAreaState?.minOrder}
          onInput={(e) => handleInputValue("minOrder", e.target.value)}
        />
        <AppInput
          label={t("Delivery Fee")}
          mandatory={true}
          type="number"
          value={selectedAreaState?.deliveryFee}
          onInput={(e) => handleInputValue("deliveryFee", e.target.value)}
        />
      </div>

      <div className="my-3 text-lg font-bold">{t("Delivery Time")}</div>
      <div className="grid grid-cols-3 gap-4">
        <AppSelect
          placeholder={t("Select Days")}
          value={selectedAreaState?.deliveryTime?.Days}
          options={daysOptions}
          onChange={(value) =>
            handleValues("deliveryTime", {
              ...selectedAreaState?.deliveryTime,
              Days: Number(value || 0),
            })
          }
        />
        <AppSelect
          placeholder={t("Select Hours")}
          value={selectedAreaState?.deliveryTime?.Hours}
          options={hourOptions}
          onChange={(value) =>
            handleValues("deliveryTime", {
              ...selectedAreaState?.deliveryTime,
              Hours: Number(value || 0),
            })
          }
        />
        <AppSelect
          placeholder={t("Select Minutes")}
          value={selectedAreaState?.deliveryTime?.Minutes}
          options={minuteOptions}
          onChange={(value) =>
            handleValues("deliveryTime", {
              ...selectedAreaState?.deliveryTime,
              Minutes: Number(value || 0),
            })
          }
        />
      </div>
    </div>
  );
}

export default ZoneForm;
